<template>
  <a-select allow-clear v-model:value="selectedKey" :mode="mode" :options="options" placeholder="请选择">
  </a-select>
</template>

<script setup lang='ts'>
import { computed } from 'vue'

const props = defineProps<{
  source: DataDic[],
  value: string[] | string,
  mode?: 'multiple' | 'tags' | 'combobox'
}>()
const emit = defineEmits(['update:value'])

const options = computed(() => props.source?.sort((a, b) => a.sort - b.sort)?.map(a => ({ label: a.name, value: a.id })))
const selectedKey = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('update:value', val)
  }
})

</script>

<style lang='scss' scoped></style>